<template>
  <div id="realestate-form">
    <b-row class="row">
      <b-col cols="5">
        <text-input
          :label="`${$t('CLIENT')} 2`"
          v-model='clientName2Input'
          :disabled="!edit"
          borderbottom
          placeholder=""
        />
      </b-col>
      <b-col cols="2"></b-col>
      <b-col cols="5">
        <text-input
          :label="`${$t('NATIONAL_ID')} 2`"
          v-model='nationalId2Input'
          :disabled="!edit"
          borderbottom
          placeholder=""
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { onMounted, ref, watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import TextInput from '@/components/TextInput';

const { useState, useActions } = createNamespacedHelpers('contractNew');

export default {
  name: 'RealestateForm',
  components: {
    TextInput,
  },
  props: {
    edit: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const { asset } = useState(['asset']);
    const { setAsset } = useActions(['setAsset']);

    const clientName2Input = ref('');
    const nationalId2Input = ref('');

    const setData = () => {
      const data = {
        meta: {
          clientName2: clientName2Input.value,
          nationalId2: nationalId2Input.value,
        }
      };
      setAsset(data);
    };

    const setDataFromState = () => {
      if ('clientName2' in asset.value.meta) {
        clientName2Input.value = asset.value.meta.clientName2;
      }

      if ('nationalId2' in asset.value.meta) {
        nationalId2Input.value = asset.value.meta.nationalId2;
      }
    };

    watch(asset, setDataFromState);
    onMounted(setDataFromState);

    return {
      setData,
      clientName2Input,
      nationalId2Input,
    };
  },
};
</script>

<style lang='scss' scoped>
@import "~@/assets/scss/colors";

#realestate-form {
  .row {
    margin-bottom: 30px;
  }
}

</style>
